
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import TextArea from '@ecl/eu-react-component-text-area';
import demoContentDefault from '@ecl/eu-specs-text-area/demo/data--default';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Playground system="eu" selectedKind="components-forms-textarea" selectedStory="default" mdxType="Playground">
  <TextArea id="example1" label={demoContentDefault.label} rows={4} helperText="This is the input's helper text." width={demoContentDefault.width} mdxType="TextArea" />
    </Playground>
    <h2>{`Disabled`}</h2>
    <Playground system="eu" selectedKind="components-forms-textarea" selectedStory="default" mdxType="Playground">
  <TextArea id="example2" label={demoContentDefault.label} rows={4} helperText="This is the input's helper text." disabled width={demoContentDefault.width} mdxType="TextArea" />
    </Playground>
    <h2>{`With error`}</h2>
    <Playground system="eu" selectedKind="components-forms-textarea" selectedStory="default" mdxType="Playground">
  <TextArea id="example3" label={demoContentDefault.label} rows={4} helperText="This is the input's helper text." invalid invalidText="Error message" width={demoContentDefault.width} mdxType="TextArea" />
    </Playground>
    <h2>{`Required`}</h2>
    <Playground system="ec" selectedKind="components-forms-textarea" selectedStory="default" mdxType="Playground">
  <TextArea id="example4" label={demoContentDefault.label} rows={4} helperText="This is the input's helper text." required requiredText="*" width={demoContentDefault.width} mdxType="TextArea" />
    </Playground>
    <h2>{`Optional`}</h2>
    <Playground system="ec" selectedKind="components-forms-textarea" selectedStory="default" mdxType="Playground">
  <TextArea id="example5" label={demoContentDefault.label} rows={4} helperText="This is the input's helper text." optionalText=" (optional)" width={demoContentDefault.width} mdxType="TextArea" />
    </Playground>
    <h2>{`Widths`}</h2>
    <h3>{`Medium`}</h3>
    <Playground system="ec" selectedKind="components-forms-textarea" selectedStory="default" mdxType="Playground">
  <TextArea id="example6" label={demoContentDefault.label} rows={4} helperText="This is the input's helper text." width="m" mdxType="TextArea" />
    </Playground>
    <h3>{`Large`}</h3>
    <Playground system="ec" selectedKind="components-forms-textarea" selectedStory="default" mdxType="Playground">
  <TextArea id="example7" label={demoContentDefault.label} rows={4} helperText="This is the input's helper text." width="l" mdxType="TextArea" />
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;